<div
  class="content-max-width steps-helper"
  [fxHide.lt-md]="model.hideOnMobile"
  [fxHide.md]="model.hideOnTablet"
  [fxHide.gt-md]="model.hideOnDesktop"
  fxLayout="row"
>
  <app-contentful-renderer
    *ngFor="let step of model.steps; let i = index"
    [model]="step"
  ></app-contentful-renderer>
</div>
